var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPath4406(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.595,
    height: 30.019,
    viewBox: "0 0 36.595 30.019",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ff3147;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M35.523,2.144H30.068c.009-.357.023-.709.023-1.072A1.071,1.071,0,0,0,29.018,0H7.576A1.071,1.071,0,0,0,6.5,1.072c0,.363.014.716.023,1.072H1.072A1.071,1.071,0,0,0,0,3.216V5.932A11.268,11.268,0,0,0,10.7,17.094a10.724,10.724,0,0,0,4.36,3.668,15.872,15.872,0,0,1-3.679,9.257H25.21a15.763,15.763,0,0,1-3.678-9.257,10.721,10.721,0,0,0,4.361-3.668,11.268,11.268,0,0,0,10.7-11.162V3.216A1.071,1.071,0,0,0,35.523,2.144ZM2.144,5.932V4.288h4.49A28.447,28.447,0,0,0,9.3,14.774,9.145,9.145,0,0,1,2.144,5.932Zm20.475,3.32-1.375,1.354.316,1.9a1.073,1.073,0,0,1-1.552,1.128L18.3,12.748l-1.712.889a1.073,1.073,0,0,1-1.552-1.128l.316-1.9L13.975,9.252a1.072,1.072,0,0,1,.594-1.824l1.908-.287.862-1.724a1.116,1.116,0,0,1,1.918,0l.862,1.724,1.908.287a1.072,1.072,0,0,1,.594,1.824Zm11.831-3.32a9.145,9.145,0,0,1-7.159,8.842A28.445,28.445,0,0,0,29.961,4.288h4.49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath4406);
export default __webpack_public_path__ + "static/media/Path 4406.684bb06c282828ab8ed96016d78c001e.svg";
export { ForwardRef as ReactComponent };